/** Shared by the builder preview and the authenticated canvas renderer. */
export function tabPresentation(style?: string) {
  if (style !== "underline") return undefined;
  return {
    tabs: { bgcolor: "background.surface" },
    list: {
      bgcolor: "transparent",
      borderBottom: "1px solid",
      borderColor: "divider",
      borderRadius: 0,
      p: 0,
      gap: 1,
      overflowX: "auto",
      flexWrap: "nowrap",
    },
    tab: {
      borderRadius: 0,
      flexShrink: 0,
      bgcolor: "transparent",
      "&.Mui-selected": { bgcolor: "transparent", color: "primary.600" },
      "&::after": { bgcolor: "transparent", height: 2 },
      "&.Mui-selected::after": { bgcolor: "primary.500" },
    },
  } as const;
}
